import adminTabs from './AdminTabs'
import adminConfigManager from './AdminConfigManager'
export default {
  adminTabs,
  adminConfigManager
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/adminView/index.js